





















































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {dateTimeDisplay} from '@/lib/util/dateFunctions';
import {BaseScenarioType, IBaseScenario, IDesignBaseScenario} from '@/lib/types/IBaseScenario';
import {designStore, lccaStore, projectStore, userStore} from '@/store/store';
import ErrorDisplay from '@/views/components/projects/ErrorDisplay.vue';
import {clearAllHttpErrors} from '@/lib/util/errors';
import {lccaPages} from '@/modules/lcca/lccaRouter';
import {DesignScenarioType} from '@/modules/design/interfaces/shared';
import {acOverlayPages, asphaltPages, concretePages, porousPages} from '@/modules/design/designRouter';
import {RoadwayClassifications} from '@/lib/data/roadwayClassification';
import {agencyCostPages} from '@/modules/agencyCost/router';
import {perRoadPages} from '@/modules/perRoad/router';
import {structurePages} from "@/modules/structure/router";

Component.registerHooks(['beforeRouteLeave']);

@Component({
  name: 'ValidatedInputPageWrapper',
  components: {ErrorDisplay},
})
export default class ValidatedInputPageWrapper extends Vue {
  @Prop() readonly headerText!: string;

  @Prop() readonly page!: number;

  @Prop({default: false}) readonly last!: boolean;

  @Prop({default: true}) readonly showDefaultCardBody!: boolean;

  @Prop() scenario!: IBaseScenario | IDesignBaseScenario;

  @Prop({default: null}) validations!: any;

  @Prop({default: () => []}) warnings!: string[];

  @Prop({default: false}) noFooter!: boolean;
  // @Prop() pages!: {link: string, text: string}[];

  @Prop({default: false}) hideNavButtons!: boolean;


  dateDisplay = dateTimeDisplay;

  get lastModified() {
    // console.log(this.scenario);
    // console.log('type:',this.scenario.scenarioType);
    return this.scenario.modified;
  }

  get httpErrors() {
    const e: any[] = [];
    return e.concat(designStore.httpErrors).concat(projectStore.httpErrors).push(userStore.httpErrors);
  }

  resetHttpErrors() {
    designStore.clearErrors();
    projectStore.clearErrors();
    userStore.clearErrors();
    lccaStore.clearErrors();
  }

  get pages(): { link: string, text: string }[] {
    let P: { link: string, text: string }[] = [];

    if (this.scenario) {
      switch (this.scenario.scenarioType) {
        case BaseScenarioType.design:

          // @ts-ignore
          switch (this.scenario.designScenarioType) {
            case DesignScenarioType.asphalt:
              P = asphaltPages;
              break;
            case DesignScenarioType.concrete:
              P = concretePages;
              break;
            case DesignScenarioType.porous:
              P = porousPages;
              break;
            case DesignScenarioType.acOverlay:
              P = acOverlayPages;
              break;
            default:
              throw Error('Design scenario type not found.');
          }

          // Truncate pages if it's a light parking lot
          // @ts-ignore
          if (this.scenario.roadwayClassification === RoadwayClassifications.parkingLotLight) {
            const maxPageNum = P.map((p) => Number(p.link)).reduce((a, b) => Math.max(a, b)).toString();

            P = P.filter((p) => ['1', maxPageNum].includes(p.link));
          }

          break;
        case BaseScenarioType.lcca:
          P = lccaPages;
          break;
        case BaseScenarioType.agencyCost:
          P = agencyCostPages;
          break;
          //   return 'Agency Cost';
        case BaseScenarioType.perRoad:
          P = perRoadPages;
          break;

        case BaseScenarioType.structure:
          P = structurePages;
          break;
        default:
          throw Error('Scenario type not found');
      }
    }
    return P;
  }

  scenarioTypes = BaseScenarioType;

  linkIsActive(page: number) {
    // Make sure page is number
    // page = Number(page);

    const allPrevPageNumbers = this.pages.filter((P) => Number(P.link) < page).map((P) => Number(P.link));
    // console.log(page, allPrevPageNumbers)

    const allValidations = allPrevPageNumbers.map((n) => (this.validations[n] ? this.validations[n].$invalid : true));
    // console.log(allValidations)
    const anyPrevPageValidationErrors = allValidations.includes(true);


    if (Number(page) === 1) {
      // console.log("ok", page)
      return true;
    }
    if (anyPrevPageValidationErrors) {
      // console.log("bad", page)
      return false;
    }
    // console.log("ok", page)
    return true;
  }

  get scenarioTypeText() {
    if (this.scenario.scenarioType === BaseScenarioType.design) {
      // @ts-ignore
      return this.scenario.designScenarioType;
    }
    switch (this.scenario.scenarioType) {
      case BaseScenarioType.lcca:
        return 'LCCA';
      case BaseScenarioType.agencyCost:
        return 'Agency Cost';
      case BaseScenarioType.perRoad:
        return 'PerRoad';
      default:
        throw Error('Scenario type text not found');
    }
  }

  get prevPage(): string | null {
    if (this.page && this.page > 1) {
      // Need to skip intermediate pages if it's a light-duty asphalt parking lot
      if (this.scenario.scenarioType === BaseScenarioType.design
          // @ts-ignore
          && this.scenario.designScenarioType === DesignScenarioType.asphalt
          // @ts-ignore
          && this.scenario.roadwayClassification === RoadwayClassifications.parkingLotLight
      ) {
        return '1';
      }

      return (this.page - 1).toString();
    }
    if (this.page) {
      return this.page.toString();
    }

    return null;
  }

  get nextPage(): string | null {
    if (this.page) {
      // Need to skip intermediate pages if it's a light-duty asphalt parking lot
      if (this.scenario.scenarioType === BaseScenarioType.design
          // @ts-ignore
          && this.scenario.designScenarioType === DesignScenarioType.asphalt
          // @ts-ignore
          && this.scenario.roadwayClassification === RoadwayClassifications.parkingLotLight
      ) {
        return '6';
      }

      return (this.page + 1).toString();
    }
    return null;
  }

  setTargetTab(scenarioType: BaseScenarioType) {
    projectStore.setScenarioTab(scenarioType);
  }

  saveWarning: null | string = null;

  save() {
    this.$emit('sync');
    clearAllHttpErrors();
    this.$emit('save');
    if (this.validations !== null && this.validations !== undefined) {
      this.validations.$touch();
    }
  }

  created() {
    this.saveWarning = null;
    this.resetHttpErrors();
  }

  mounted() {
    // Sets the target tab type in case the user navigates straight to a scenario-editing URL.
    // Maybe overkill, but shouldn't be high-cost and is hopefully more intuitive to always end up on the correct
    // tab type in scenario selection.
    if (this.scenario) {
      this.setTargetTab(this.scenario.scenarioType);
    }
  }

  beforeRouteLeave() {
    this.save();
  }
}
